import React, { useEffect, useState, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { FiCheckCircle, FiUpload } from "react-icons/fi";
import server from "../../../api/server.js";
import { useToast } from '../../../context/ToastContext.jsx';
import { X } from "lucide-react";
const ContactsPage = ({ state, category, serviceID, clientID }) => {
  const { showToast } = useToast();
  const [formData, setFormData] = useState({
    category: "",
    description: "",
    mobile_number: "",
    preferred_contact_method: "Any",
    file_data: []
  });
  const fileInputRef = useRef(null);

  // Trigger file input click programmatically
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const [isSubmitted, setIsSubmitted] = useState(false); // Tracks if form is submitted
  const [service_id, setService_id] = useState(null);
  const [email, setEmail] = useState(null);
  const [client_id, setClient_id] = useState(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Process each file
    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Add the new file data to the existing array
        setFormData(prevState => ({
          ...prevState,
          file_data: [...prevState.file_data, reader.result]
        }));
      };
      reader.readAsDataURL(file);
    });
    
    // Reset the file input to allow selecting the same file again
    e.target.value = '';
  };

  function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fileDataArray = formData.file_data.length > 0 ? formData.file_data : [];
    let obj = {
      email, client_id, service_id: Array.isArray(service_id) ? service_id[0] : service_id,
      menu: 'apps',
      submenu: undefined,
      ...formData,
      file_data: fileDataArray
    }
    let resp = await server.contactUs(obj);
    if(resp.status === 200) {
      setIsSubmitted(true); // Show success message
      showToast('Thank you for contacting us. We will get back to you soon.', "success")
      handleClose();
    }
  };

  const handleClose = () => {
    state(true);
  };

  useEffect(() => {
    if (category) {
      setFormData((prevState) => ({ ...prevState, category: category }));
    }
  }, [category]);


  useEffect(() => {
    const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
    if (user) {
      setEmail(user.email);
    }
    if (serviceID) {
      setService_id(serviceID);
    }
    if(clientID){
      setClient_id(clientID)
    }
  }, [serviceID, clientID]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center" style={{zIndex: "99", background: "rgba(0, 0, 0, 0.5)"}}>
      <div className="bg-white rounded-md shadow-lg w-full max-w-md mx-4 px-4 py-3 overflow-auto" style={{height: "93.5vh", maxWidth: "800px"}}>
        {isSubmitted ? (
          // Success Message UI
          <div className="text-center">
            <div className="flex justify-end">
              <button
                onClick={handleClose}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes />
              </button>
            </div>
            <div className="flex justify-center">
              <FiCheckCircle className="text-green-500" size={48} />
            </div>
            <h2 className="text-lg font-semibold mt-2" style={{fontSize: "1rem"}}>
              Thanks for Contacting us.
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              Our team will reach out to you soon through your preferred contact
              method.
            </p>
          </div>
        ) : (
          // Contact Form UI
          <>
            <div className="flex justify-between items-center pb-2 border-b">
              <h2 className="text-xl font-semibold text-gray-900">
                Contact Us
              </h2>
              <FaTimes onClick={handleClose} style={{color: "slategray", cursor: "pointer"}}/>
            </div>

            <form onSubmit={handleSubmit} className="pt-4" style={{height: "78vh", overflow: "auto"}}>
              <div className="mb-4">
                <label className="block mb-1" style={{ fontSize: "14px" }}>
                  Category<span className="text-red-500">*</span>
                </label>
                <select
                  name="category"
                  value={formData['category']}
                  onChange={handleChange}
                  className="w-full border rounded p-2 global-input"
                  required
                  style={{ fontSize: "14px" }}
                >
                  <option value="">Select a category</option>
                  <option value="Product Demo Request">
                    Product Demo Request
                  </option>
                  <option value="Pricing & Billing">Pricing & Billing</option>
                  <option value="Feature Request">Feature Request</option>
                  <option value="feedback">Feedback</option>
                  <option value="Report a Bug">Report a Bug</option>
                  <option value="others">Others</option>
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Upload Image<span className="text-red-500">*</span></label>
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  multiple
                  className="hidden global-input" // Hide the original input
                />
                
                {/* Custom styled button */}
                <button
                  type="button"
                  onClick={triggerFileInput}
                  className="flex items-center justify-center px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                  style={{ height: "40px", borderRadius: "4px", fontSize: "14px" }}
                >
                  <FiUpload className="mr-2" />
                  Choose Files
                </button>
              </div>

              <div className="mb-4">
                <label className="block mb-1" style={{ fontSize: "14px" }}>
                  Description<span className="text-red-500">*</span>
                </label>
                <textarea
                  name="description"
                  value={formData['description']}
                  onChange={handleChange}
                  placeholder="Please describe your inquiry in detail..."
                  className="w-full border rounded p-2 h-24 global-input"
                  required
                  style={{ fontSize: "14px" }}
                />
              </div>

              <div className="mb-4">
                <label className="block mb-1" style={{ fontSize: "14px" }}>
                  Mobile Number{" "}
                  <span
                    className="text-gray-500 text-sm"
                    style={{ fontSize: "14px" }}
                  >
                    Optional
                  </span>
                </label>
                <div className="flex">
                  <select
                    className="border rounded-l p-2 w-40 global-input"
                    name="countryCode"
                    defaultValue="+91 (India)"
                    style={{ fontSize: "14px" }}
                  >
                    <option value="+91 (India)">+91 (India)</option>
                    <option value="+1 (US/Canada)">+1 (US/Canada)</option>
                    <option value="+44 (UK)">+44 (UK)</option>
                    <option value="+971 (UAE)">+971 (UAE)</option>
                    <option value="+63 (Philippines)">+63 (Philippines)</option>
                    <option value="+61 (Australia)">+61 (Australia)</option>
                    <option value="+49 (Germany)">+49 (Germany)</option>
                    <option value="+33 (France)">+33 (France)</option>
                  </select>
                  <input
                    type="text"
                    name="mobile_number"
                    value={formData['mobile_number']}
                    onChange={handleChange}
                    placeholder="For faster resolution"
                    className="w-full border border-l-0 rounded-r p-2 global-input"
                    style={{ fontSize: "14px" }}
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1" style={{ fontSize: "12px" }}>
                  Adding a phone number enables us to reach you faster
                </p>
              </div>

              <div className="mb-6">
                <label className="block mb-1" style={{ fontSize: "14px" }}>
                  Preferred Contact Method<span className="text-red-500">*</span>
                </label>
                <select
                  name="preferred_contact_method"
                  value={formData['preferred_contact_method']}
                  onChange={handleChange}
                  className="w-full border rounded p-2 global-input"
                  required
                  style={{ fontSize: "14px" }}
                >
                  <option value="Any">Any</option>
                  <option value="Email">Email</option>
                  <option value="Phone Call">Phone Call</option>
                  <option value="WhatsApp">WhatsApp</option>
                </select>
              </div>

            </form>
            <hr style={{marginBottom: "10px"}}/>
            <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-100"
                  style={{ padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                  style={{ padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
                >
                  Submit
                </button>
              </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactsPage;
